import { type ReactNode } from 'react';
import withAuthentication from 'src/hocs/withAuthentication';
import TimezoneProvider from './timezone-sync-provider';
import { GlobalCallProvider } from './global-call-provider-context';
import { NotificationsPushProvider } from 'src/modules/notifications/contexts/notifications-push-provider';
import { NotificationsRealtimeProvider } from 'src/modules/notifications/contexts/notifications-realtime-provider';
import { RealtimeProvider } from 'src/modules/shared/realtime/contexts/realtime-provider';

interface AuthenticatedProvidersProps {
  children: ReactNode;
}

/**
 * Provides authenticated context providers for the application.
 */
const AuthenticatedProviders: React.FC<AuthenticatedProvidersProps> = ({
  children,
}) => {
  const AuthenticatedTimezoneProvider = withAuthentication(TimezoneProvider);
  const AuthenticatedCallProviderProvider =
    withAuthentication(GlobalCallProvider);
  const AuthenticatedNotificationsPushProvider = withAuthentication(
    NotificationsPushProvider
  );
  const AuthenticatedNotificationsRealtimeProvider = withAuthentication(
    NotificationsRealtimeProvider
  );
  const AuthenticatedRealtimeProvider = withAuthentication(RealtimeProvider);

  return (
    <AuthenticatedCallProviderProvider>
      <AuthenticatedTimezoneProvider>
        <AuthenticatedNotificationsPushProvider>
          <AuthenticatedRealtimeProvider>
            <AuthenticatedNotificationsRealtimeProvider>
              {children}
            </AuthenticatedNotificationsRealtimeProvider>
          </AuthenticatedRealtimeProvider>
        </AuthenticatedNotificationsPushProvider>
      </AuthenticatedTimezoneProvider>
    </AuthenticatedCallProviderProvider>
  );
};

export default AuthenticatedProviders;
